var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBook(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 3056"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 257",
    cx: 40,
    cy: 40,
    r: 40,
    fill: "#F6F6FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M40.2174 53.5218C42.3913 51.9276 48.3913 49.6957 55 53.5218V29.6087M25 29.1739V53.5218C27.1739 51.9276 33.1739 49.6957 39.7826 53.5218V30.0435M25 29.1126C27.1739 27.5184 33.1739 25.2865 39.7826 29.1126M40.2174 29.1126C42.3913 27.5184 48.3913 25.2865 55 29.1126",
    stroke: "#825DFC",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBook);
export default __webpack_public_path__ + "static/media/book.e37c9f19636a362473ff1d1aa447e809.svg";
export { ForwardRef as ReactComponent };